import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseSocialLoginButton } from "@faire/retailer-visitor-shared/components/SocialSignOnButtons/BaseSocialLoginButton";
import { useSSOErrorStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOErrorStore";
import { useSSOStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOStore";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { logError } from "@faire/web--source/common/logging";
import { parseQueryParams } from "@faire/web--source/common/query-params/parseQueryParams";
import { faireBaseUrl } from "@faire/web--source/common/routes/faireBaseUrl";
import { SocialSignOnProvider } from "@faire/web-api--source/indigofair/data/SocialSignOnProvider";
import React from "react";
import { useLocation } from "react-router-dom";
var PROVIDER = SocialSignOnProvider.OKTA;
export var OktaLoginButton = function(props) {
    var isOnSignIn = props.isOnSignIn, sourceId = props.sourceId;
    var _useSSOStore = useSSOStore(), userClickedSSOButton = _useSSOStore.userClickedSSOButton, recordSSOButtonClick = _useSSOStore.recordSSOButtonClick;
    var _useSSOErrorStore = useSSOErrorStore(), errorMessage = _useSSOErrorStore.errorMessage, setErrorMessage = _useSSOErrorStore.setErrorMessage;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var baseurl = faireBaseUrl().replace(/https:\/\/www\.|http:\/\/(localhost)/, function(_, localhost) {
        return localhost !== null && localhost !== void 0 ? localhost : "";
    });
    var isLocal = baseurl.startsWith("localhost");
    var location = useLocation();
    var queryParams = parseQueryParams(location.search);
    var redirectTo = queryParams.get("redirectTo");
    var redirectURI;
    if (redirectTo == null) {
        redirectURI = "".concat(baseurl, "/admin2");
    } else {
        redirectURI = redirectTo;
    }
    var onClick = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var port;
            return _ts_generator(this, function(_state) {
                if (!userClickedSSOButton && errorMessage) {
                    recordSSOButtonClick();
                } else {
                    try {
                        if (isLocal) {
                            port = baseurl.replace(/^localhost/, "");
                            getWindowOrThrow().open("http://localhost".concat(port, "/api/okta_sso/authorize?loginType=LOCALHOST&clientRedirectURI=").concat(redirectURI), "_self");
                        } else {
                            getWindowOrThrow().open("https://www.".concat(baseurl, "/api/okta_sso/authorize?loginType=BROWSER&clientRedirectURI=").concat(redirectURI), "_self");
                        }
                        recordSSOButtonClick();
                    } catch (error) {
                        logError(error, {
                            tags: {
                                signInType: "SSO",
                                provider: PROVIDER,
                                code: "redirect_failed"
                            }
                        });
                        setErrorMessage(strictLocalize({
                            id: "eyz2Nq",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Failed to redirect to Okta SSO."
                                }
                            ]
                        }));
                    }
                }
                return [
                    2
                ];
            });
        });
        return function onClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsx(BaseSocialLoginButton, {
        onClick: onClick,
        socialProvider: PROVIDER,
        loading: false,
        isOnSignIn: isOnSignIn,
        sourceId: sourceId
    });
};
